import HeroSection, { HeroSectionProps } from "@components/E-Book/Herosection";
import NewLayout from "@components/new-ui/Layout";
import Image from "next/image";

const HeroSectionData: HeroSectionProps = {
    title: "Hit your Marketing OKRs by Engaging Prospects on WhatsApp",
    listHeading:
        "Make your lead gen efforts really count with WhatsApp Marketing. Get actionable takeaways to boost marketing qualified leads and deliver sales-ready prospects that earn you a seat at the table:",
    listText: [
        { label: "WhatsApp delivers a whopping 45-60% conversions. Find out how to reach customers where they're most responsive." },
        { label: "Scale your marketing with smart automation—from generating leads to winning deals." },
        { label: "Segment your audience, WhatsApp Business API helps you segment your audience, automate responses, and deliver bespoke experiences at scale." },
    ],
    buttonText: "Download your free Ebook now!",
    mediaUrl: "https://assets.gallabox.com/gb-home/ebook/why-whatsapp-for-business.png",
    altMedia: "gallabox-e-book",
    ebookName: "marketing-ebook",
};

const EbookWhatsappForMarketing: React.FC = () => {
    return (
        <NewLayout
            title="WhatsApp Business for hitting marketing OKRs | Free ebook"
            description="Make your lead gen efforts really count with this actionable ebook on mastering WhatsApp Business automation for hitting your marketing goals every month."
            canonical="https://gallabox.com/resources/whatsapp-for-marketing-ebook"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/ebook/wa-for-marketing-ebook-og.png" }}
            keywords="whatsapp for marketing, how to use whatsapp marketing, using whatsapp for marketing, how to use whatsapp business for marketing"
        >
            <HeroSection {...HeroSectionData} />
            <section className="flex flex-col pb-10 pr-12">
                <div className="px-8 max-w-6xl mx-auto client-logos flex flex-col gap-3">
                    <Image width={221} height={56} src="/frame.png" alt={"Frame"} className="flex-shrink" />
                    <div className="lg:flex justify-between items-center">
                        <h3 className="text-2xl lg:text-3xl font-semibold text-gray-900 mb-14">
                            Trusted by over <span className="font-bold">10,000 companies</span> across <span className="font-bold">40+ </span> countries
                        </h3>
                        <div className="flex justify-center mb-9">
                            <Image
                                width={730}
                                height={56}
                                src="https://assets.gallabox.com/gb-home/ebook/client-logo.png"
                                alt="client-logo-data"
                                className="flex-shrink lg:block hidden"
                            />
                            <Image
                                width={730}
                                height={56}
                                src="https://assets.gallabox.com/gb-home/ebook/client-logo.png"
                                alt="client-logo-data"
                                className="flex-shrink lg:hidden"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </NewLayout>
    );
};

export default EbookWhatsappForMarketing;
